import { useNonF2fMedicalCategories } from '@/entities/medical-category';
import { EMedicalCategoryCategory, MedicalCategoryModel } from '@/entities/medical-category/model/MedicalCategory';
import { DiagnosisCategoryType } from '@/models/diagnosis';

import { getCategoryPath as getTelemedicineCategoryPath, useTelemedicineRequest } from '@/entities/telemedicine';
import { ROUTES } from '@/types/common';
import { MEDICAL_CATEGORY_CONFIG } from '../lib/constants';

const MORE_CATEGORY_PATH = `${ROUTES.TELEMEDICINE.CATEGORIES.path}`;

const MORE_CATEGORY = {
  id: 'more',
  name: '전체 보기',
  iconUrl: 'https://d2m9duoqjhyhsq.cloudfront.net/diagnoses/etc/more_category.png',
};

const getCategoryType = (category: MedicalCategoryModel): DiagnosisCategoryType => {
  switch (category.category) {
    case EMedicalCategoryCategory.TREATMENT:
      return DiagnosisCategoryType.Treatment;
    case EMedicalCategoryCategory.DEPARTMENT:
      return DiagnosisCategoryType.Department;
    case EMedicalCategoryCategory.VACCINATION:
      return DiagnosisCategoryType.Vaccination;
    default:
      return DiagnosisCategoryType.Treatment;
  }
};

const useMedicalCategoryDisplayViewModel = (size = MEDICAL_CATEGORY_CONFIG.DEFAULT_DISPLAY_SIZE - 1) => {
  const { onClickTelemedicineRequest } = useTelemedicineRequest();
  const { medicalCategories, isLoading, error } = useNonF2fMedicalCategories(size);

  const getCategoryPath = (category: MedicalCategoryModel) => {
    return getTelemedicineCategoryPath(category.id, getCategoryType(category));
  };

  const onClickCategory = (category: MedicalCategoryModel) => {
    const categoryType = getCategoryType(category);

    onClickTelemedicineRequest({
      categoryId: category.id,
      type: categoryType,
      redirectUrl: getTelemedicineCategoryPath(category.id, categoryType),
    });
  };

  return {
    medicalCategories: medicalCategories,
    moreCategory: MORE_CATEGORY,
    isLoading,
    error,
    moreCategoryPath: MORE_CATEGORY_PATH,
    getCategoryPath,
    onClickCategory,
  };
};

export default useMedicalCategoryDisplayViewModel;
